import globalStyles from '../../styles/exported.module.scss';
import { svgIconsTestIds } from '../tests/testIds';

export const ExternalIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...(className && { className })}
    width="28"
    height="22"
    viewBox="0 0 15 21"
    fill="none"
    data-testid={svgIconsTestIds.externalIcon}
  >
    <path
      d="M13.432 12.7105V15.7703C13.432 16.5646 12.788 17.2079 11.9928 17.2079H2.4392C1.644 17.2079 1 16.5646 1 15.7703V6.11548C1 5.32117 1.644 4.67789 2.4392 4.67789H5.19776"
      stroke={globalStyles.bdPrimaryBoostedBlue}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M14.888 3.112L7.104 10.8873"
      stroke={globalStyles.bdPrimaryBoostedBlue}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M8.72852 3H15.0005V9.26498"
      stroke={globalStyles.bdSecondaryLightBlue}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);
